(function () {
    'use strict';

    angular
        .module('ib-ancillaries-priority-module')
        .controller('AncillariesPriorityController', AncillariesPriorityController);

    AncillariesPriorityController.$inject = ['$window', '$rootScope', 'MenusConstants', '$scope', 'localStorageService', 'DatalayerMenusService'];
    function AncillariesPriorityController ($window, $rootScope, MenusConstants, $scope, localStorageService, DatalayerMenusService) {
        const vm = this;
        vm.deletePriority = deletePriority;

        function deletePriority (deleteInfo) {
            let deletePriorityInfo, deletePriority = [];
            vm.basketFunctions.isLoading();
            deletePriorityInfo = createDeleteInfo(deleteInfo);
            deletePriority.push(deletePriorityInfo);
            DatalayerMenusService.deletePriorityBoarding(deleteInfo);
            localStorageService.set('deletePriority', deletePriority);
            vm.basketFunctions.deleteAncillariesService.deleteAncillarie(deletePriority).then(() => {
                deletePrioritySuccess();
                $rootScope.$broadcast('updatedPriorityInfoModel', deletePriority);
                localStorageService.remove('deletePriority');
                vm.basketFunctions.calculateAllBasket( '/' + localStorageService.get('actualStepFlow'));
                vm.basketFunctions.saveHeaderModel();
                vm.basketFunctions.isNotLoading();
                $rootScope.$broadcast('basketUpdateCommonHeader');
                //updateAncillariesDataLayer();
            }, (error) => {
                vm.basketFunctions.isNotLoading();
                vm.basketFunctions.modalService.setErrorMessage(error.message);
                vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                vm.basketFunctions.modalService.isError(error);
                vm.basketFunctions.collapseHeader.closeCollapse();
            });

            function createDeleteInfo (deleteInfo) {
                let i, j, selectedPriorityBoarding = localStorageService.get('selectedPriorityBoarding'),
                    deleteStructure = {
                        type: 'PRIORITY_BOARDING',
                        segments: [{
                            id: deleteInfo.id,
                            passengerIds: []
                        }]
                    };
                for (i = 0; i < selectedPriorityBoarding.length; i++) {
                    for (j = 0; j < selectedPriorityBoarding[i].trips.length; j++) {
                        if (selectedPriorityBoarding[i].trips[j].id === deleteInfo.id) {
                            if (selectedPriorityBoarding[i].trips[j].checkedTrip) {
                                deleteStructure.segments[0].passengerIds.push(selectedPriorityBoarding[i].id);
                            }
                        }
                    }
                }
                return deleteStructure;
            }

            function deletePrioritySuccess () {
                let i, deletePriority = localStorageService.get('deletePriority');
                for (i = 0; i < vm.model.info.trips.length; i++) {
                    if (vm.model.info.trips[i].id === deletePriority[0].segments[0].id) {
                        vm.model.info.amount -= vm.model.info.trips[i].amount;
                        vm.model.info.trips.splice(i, 1);
                    }
                }
                if (vm.model.info.trips.length == 0) {
                    vm.model.hasPriorityBoarding = false;
                    $rootScope.$broadcast('cleanPriorityBoarding');
                }
            }
            /* function updateAncillariesDataLayer() {
                 var selectedAncillaries = localStorageService.get('headerModel').shoppingBasket,
                     totalBaggagesPrice = 0, totalSeatsPrice = 0, totalBaggages = 0, totalSeats = 0;

                 if (selectedAncillaries) {
                     getBaggagesInfo();
                     getSeatsInfo();
                     DatalayerUtilsService.updateDatalayerForAncillaries(
                         true,
                         DatalayerConstants.DATALAYER_EVENT_TYPES.CLICK,
                         totalBaggages,
                         totalBaggagesPrice,
                         totalSeats,
                         totalSeatsPrice,
                         selectedAncillaries.insurance.hasInsurance ? selectedAncillaries.insurance.info.type : '',
                         selectedAncillaries.insurance.hasInsurance ? selectedAncillaries.insurance.total.total : 0,
                         0
                     );
                 }

             } */
        }

    }
})();
